/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Notlist_Storefront1Inputs */

const id_privacy_notlist_storefront1 = /** @type {(inputs: Privacy_Notlist_Storefront1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toko atau pasar: Kami tidak menjual game atau menyediakan opsi pembelian apa pun. Fokus kami adalah menyediakan informasi dan data tentang Epic Games Store.`)
};

const ms_privacy_notlist_storefront1 = /** @type {(inputs: Privacy_Notlist_Storefront1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kedai atau pasaran: Kami tidak menjual permainan atau menyediakan sebarang pilihan pembelian. Tumpuan kami adalah menyediakan maklumat dan data tentang Epic Games Store.`)
};

const da_privacy_notlist_storefront1 = /** @type {(inputs: Privacy_Notlist_Storefront1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En butik eller markedsplads: Vi sælger ikke spil eller giver nogen købsmuligheder. Vores fokus er at give information og data om Epic Games Store.`)
};

const de_privacy_notlist_storefront1 = /** @type {(inputs: Privacy_Notlist_Storefront1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein Geschäft oder Marktplatz: Wir verkaufen keine Spiele oder bieten keine Kaufmöglichkeiten an. Unser Fokus liegt auf der Bereitstellung von Informationen und Daten über den Epic Games Store.`)
};

const en_us2_privacy_notlist_storefront1 = /** @type {(inputs: Privacy_Notlist_Storefront1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A storefront or marketplace: We do not sell games or provide any purchasing options. Our focus is on providing information and data about the Epic Games Store.`)
};

const es_es2_privacy_notlist_storefront1 = /** @type {(inputs: Privacy_Notlist_Storefront1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una tienda o mercado: No vendemos juegos ni proporcionamos opciones de compra. Nos enfocamos en proporcionar información y datos sobre la Epic Games Store.`)
};

const es_mx2_privacy_notlist_storefront1 = /** @type {(inputs: Privacy_Notlist_Storefront1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una tienda o mercado: No vendemos juegos ni proporcionamos opciones de compra. Nos enfocamos en proporcionar información y datos sobre la Epic Games Store.`)
};

const fil_privacy_notlist_storefront1 = /** @type {(inputs: Privacy_Notlist_Storefront1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Isang storefront o marketplace: Hindi kami nagbebenta ng laro o nagbibigay ng anumang opsyon sa pagbili. Ang aming pokus ay sa pagbibigay ng impormasyon at datos tungkol sa Epic Games Store.`)
};

const fr_privacy_notlist_storefront1 = /** @type {(inputs: Privacy_Notlist_Storefront1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une boutique ou un marché : Nous ne vendons pas de jeux et ne fournissons aucune option d'achat. Notre objectif est de fournir des informations et des données sur l'Epic Games Store.`)
};

const it_privacy_notlist_storefront1 = /** @type {(inputs: Privacy_Notlist_Storefront1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un negozio o mercato: Non vendiamo giochi né forniamo opzioni di acquisto. Il nostro obiettivo è fornire informazioni e dati sull'Epic Games Store.`)
};

const hu_privacy_notlist_storefront1 = /** @type {(inputs: Privacy_Notlist_Storefront1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bolt vagy piactér: Nem árulunk játékokat és nem biztosítunk vásárlási lehetőségeket. A hangsúly az Epic Games Store-ról szóló információk és adatok szolgáltatásán van.`)
};

const nl_privacy_notlist_storefront1 = /** @type {(inputs: Privacy_Notlist_Storefront1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een winkel of marktplaats: We verkopen geen games of bieden geen aankoopopties. Onze focus ligt op het verstrekken van informatie en gegevens over de Epic Games Store.`)
};

const no_privacy_notlist_storefront1 = /** @type {(inputs: Privacy_Notlist_Storefront1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En butikk eller markedsplass: Vi selger ikke spill eller gir noen kjøpsmuligheter. Vårt fokus er å gi informasjon og data om Epic Games Store.`)
};

const pl_privacy_notlist_storefront1 = /** @type {(inputs: Privacy_Notlist_Storefront1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sklepem ani marketplacem: Nie sprzedajemy gier ani nie udostępniamy opcji zakupu. Skupiamy się na dostarczaniu informacji i danych o Epic Games Store.`)
};

const pt_br2_privacy_notlist_storefront1 = /** @type {(inputs: Privacy_Notlist_Storefront1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma loja ou mercado: não vendemos jogos nem oferecemos opções de compra. Nosso foco é fornecer informações e dados sobre o Epic Games Store.`)
};

const pt_privacy_notlist_storefront1 = /** @type {(inputs: Privacy_Notlist_Storefront1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma loja ou marketplace: Não vendemos jogos nem fornecemos opções de compra. O nosso foco é fornecer informações e dados sobre a Epic Games Store.`)
};

const ro_privacy_notlist_storefront1 = /** @type {(inputs: Privacy_Notlist_Storefront1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un magazin sau marketplace: Nu vindem jocuri și nu oferim opțiuni de cumpărare. Ne concentrăm pe furnizarea de informații și date despre Epic Games Store.`)
};

const fi_privacy_notlist_storefront1 = /** @type {(inputs: Privacy_Notlist_Storefront1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kauppa tai markkinapaikka: Emme myy pelejä tai tarjoa ostomahdollisuuksia. Keskitymme tarjoamaan tietoa Epic Games Storesta.`)
};

const sv_privacy_notlist_storefront1 = /** @type {(inputs: Privacy_Notlist_Storefront1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En butik eller marknadsplats: Vi säljer inte spel eller tillhandahåller köpalternativ. Vårt fokus är att tillhandahålla information och data om Epic Games Store.`)
};

const vi_privacy_notlist_storefront1 = /** @type {(inputs: Privacy_Notlist_Storefront1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Một cửa hàng hoặc chợ: Chúng tôi không bán game hoặc cung cấp bất kỳ tùy chọn mua hàng nào. Trọng tâm của chúng tôi là cung cấp thông tin và dữ liệu về Epic Games Store.`)
};

const tr_privacy_notlist_storefront1 = /** @type {(inputs: Privacy_Notlist_Storefront1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bir mağaza veya pazar yeri: Oyun satmıyoruz veya herhangi bir satın alma seçeneği sunmuyoruz. Odağımız, Epic Games Store hakkında bilgi ve veri sağlamaktır.`)
};

const cs_privacy_notlist_storefront1 = /** @type {(inputs: Privacy_Notlist_Storefront1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obchod nebo tržiště: Neprodáváme hry ani neposkytujeme žádné možnosti nákupu. Naším zaměřením je poskytovat informace a data o Epic Games Store.`)
};

const bg_privacy_notlist_storefront1 = /** @type {(inputs: Privacy_Notlist_Storefront1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Магазин или пазар: Ние не продаваме игри и не предоставяме опции за покупка. Фокусът ни е да предоставяме информация и данни за Epic Games Store.`)
};

const ru_privacy_notlist_storefront1 = /** @type {(inputs: Privacy_Notlist_Storefront1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Магазином или торговой площадкой: Мы не продаём игры и не предоставляем вариантов покупки. Наша цель — предоставлять информацию и данные об Epic Games Store.`)
};

const uk_privacy_notlist_storefront1 = /** @type {(inputs: Privacy_Notlist_Storefront1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Магазином: Ми не продаємо ігри та не надаємо можливостей покупки. Наша мета — надавати інформацію та дані про Epic Games Store.`)
};

const ar_privacy_notlist_storefront1 = /** @type {(inputs: Privacy_Notlist_Storefront1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`متجرًا أو سوقًا: لا نبيع الألعاب أو نقدم خيارات شراء. تركيزنا هو توفير المعلومات والبيانات حول Epic Games Store.`)
};

const hi_privacy_notlist_storefront1 = /** @type {(inputs: Privacy_Notlist_Storefront1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्टोरफ़्रंट या बाज़ार: हम गेम नहीं बेचते हैं।`)
};

const th_privacy_notlist_storefront1 = /** @type {(inputs: Privacy_Notlist_Storefront1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`หน้าร้านหรือตลาด: เราไม่ได้ขายเกมหรือให้ตัวเลือกในการซื้อ จุดสนใจของเราคือการให้ข้อมูลและข้อมูลเกี่ยวกับ Epic Games Store`)
};

const ja_privacy_notlist_storefront1 = /** @type {(inputs: Privacy_Notlist_Storefront1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ストアフロントやマーケットプレイス：ゲームを販売したり、購入オプションを提供したりしていません。Epic Games Store に関する情報とデータを提供することに重点を置いています。`)
};

const zh_cn2_privacy_notlist_storefront1 = /** @type {(inputs: Privacy_Notlist_Storefront1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`商店或市场：我们不销售游戏，也不提供任何购买途径。我们的重点是提供关于Epic游戏商城的各种信息和数据。`)
};

const zh_hant1_privacy_notlist_storefront1 = /** @type {(inputs: Privacy_Notlist_Storefront1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`商店或市場：我們不銷售遊戲，也不提供任何購買途徑。我們的重點是提供關於Epic遊戲商城的各種資訊和資料。`)
};

const ko_privacy_notlist_storefront1 = /** @type {(inputs: Privacy_Notlist_Storefront1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`스토어 또는 마켓플레이스: 게임을 판매하거나 구매 옵션을 제공하지 않습니다. Epic Games Store에 대한 정보와 데이터를 제공하는 데 초점을 맞추고 있습니다.`)
};

/**
* | output |
* | --- |
* | "A storefront or marketplace: We do not sell games or provide any purchasing options. Our focus is on providing information and data about the Epic Games Store." |
*
* @param {Privacy_Notlist_Storefront1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const privacy_notlist_storefront1 = /** @type {((inputs?: Privacy_Notlist_Storefront1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Notlist_Storefront1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_privacy_notlist_storefront1(inputs)
	if (locale === "ms") return ms_privacy_notlist_storefront1(inputs)
	if (locale === "da") return da_privacy_notlist_storefront1(inputs)
	if (locale === "de") return de_privacy_notlist_storefront1(inputs)
	if (locale === "en-US") return en_us2_privacy_notlist_storefront1(inputs)
	if (locale === "es-ES") return es_es2_privacy_notlist_storefront1(inputs)
	if (locale === "es-MX") return es_mx2_privacy_notlist_storefront1(inputs)
	if (locale === "fil") return fil_privacy_notlist_storefront1(inputs)
	if (locale === "fr") return fr_privacy_notlist_storefront1(inputs)
	if (locale === "it") return it_privacy_notlist_storefront1(inputs)
	if (locale === "hu") return hu_privacy_notlist_storefront1(inputs)
	if (locale === "nl") return nl_privacy_notlist_storefront1(inputs)
	if (locale === "no") return no_privacy_notlist_storefront1(inputs)
	if (locale === "pl") return pl_privacy_notlist_storefront1(inputs)
	if (locale === "pt-BR") return pt_br2_privacy_notlist_storefront1(inputs)
	if (locale === "pt") return pt_privacy_notlist_storefront1(inputs)
	if (locale === "ro") return ro_privacy_notlist_storefront1(inputs)
	if (locale === "fi") return fi_privacy_notlist_storefront1(inputs)
	if (locale === "sv") return sv_privacy_notlist_storefront1(inputs)
	if (locale === "vi") return vi_privacy_notlist_storefront1(inputs)
	if (locale === "tr") return tr_privacy_notlist_storefront1(inputs)
	if (locale === "cs") return cs_privacy_notlist_storefront1(inputs)
	if (locale === "bg") return bg_privacy_notlist_storefront1(inputs)
	if (locale === "ru") return ru_privacy_notlist_storefront1(inputs)
	if (locale === "uk") return uk_privacy_notlist_storefront1(inputs)
	if (locale === "ar") return ar_privacy_notlist_storefront1(inputs)
	if (locale === "hi") return hi_privacy_notlist_storefront1(inputs)
	if (locale === "th") return th_privacy_notlist_storefront1(inputs)
	if (locale === "ja") return ja_privacy_notlist_storefront1(inputs)
	if (locale === "zh-CN") return zh_cn2_privacy_notlist_storefront1(inputs)
	if (locale === "zh-Hant") return zh_hant1_privacy_notlist_storefront1(inputs)
	return ko_privacy_notlist_storefront1(inputs)
});
export { privacy_notlist_storefront1 as "privacy.notList.storefront" }